<template>
<div>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
    <v-app-bar-nav-icon @click="toggle=!toggle"></v-app-bar-nav-icon>
    <v-toolbar-title class="hidden-sm-and-down font-weight-light" v-text="$route.name" />
    <v-spacer />	 
    <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{on}">
        <v-btn class="ml-2" min-width="0" text v-on="on">
          <v-icon>person</v-icon>
        </v-btn>
      </template>	
      <v-list nav>
        <v-list-item>
          <v-list-item-title>{{ user.email }}</v-list-item-title>
        </v-list-item>
        <v-divider class="mb-2" />      
        <v-list-item @click.prevent="userRoute()">
          <v-list-item-title><v-icon>settings</v-icon> Settings</v-list-item-title>
        </v-list-item>
        <v-list-item @click.prevent="logout()">
          <v-list-item-title><v-icon>logout</v-icon> Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
	</v-app-bar>

	<v-navigation-drawer id="navigation-drawer" mobile-break-point="960" app width="285" v-model="toggle"> 
    <v-list>
      <v-list-item>
        <v-list-item-content>         
          <v-list-item-title>
            <img id="logo" src="@/assets/logo.png" width="40%" height="auto" /> 
          </v-list-item-title>          
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider class="mb-8" />
    <v-list shaped nav>    
       <v-list-item-group color="primary">      

        <v-list-item v-if="hasRole('Ledger User')" to="/my-business">
          <v-list-item-icon><v-icon>dashboard</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>My Business</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

         <v-list-item v-if="hasRole('Ledger User')" to="/recycling-ledger">
          <v-list-item-icon><v-icon>book</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>My Ledger</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group v-if="hasRole('Login User')" prepend-icon="trending_up" append-icon="expand_more" :value="false" no-action color="primary">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Market Intelligence</v-list-item-title>
            </v-list-item-content>
          </template>
          <div v-for="item in getItemsDashboard" :key="item.pbiToken">
            <v-list-item id="naviMarketButton" v-if="hasRole(item.role) || hasRole('Login User')" :to="item.to" >       
              <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-if="!hasRole(item.role)"><v-badge content="Pro">{{item.name}}</v-badge></v-list-item-title>
                <v-list-item-title v-else>{{item.name}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>      
          </div>
        </v-list-group>

        <v-list-item v-if="hasRole('Login User')" to="/insights-dashboard">
          <v-list-item-icon><v-icon>emoji_objects</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-if="!hasRole('PBI Report 1')"><v-badge content="Pro">Market Insights</v-badge></v-list-item-title>
            <v-list-item-title v-else>Market Insights</v-list-item-title>
          </v-list-item-content>
        </v-list-item>       

        <v-list-group v-if="hasRole('Admin')" prepend-icon="settings" append-icon="expand_more" :value="false" no-action color="primary">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Admin</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item id="naviAdminButton" to="/users">
            <v-list-item-icon><v-icon>group</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Users</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

            <v-list-item id="naviAdminButton" to="/company">
            <v-list-item-icon><v-icon>domain</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Companies</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item id="naviAdminButton" to="/app-settings">
            <v-list-item-icon><v-icon>settings</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>App Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item> 
        </v-list-group>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { hasRole } from '@/mixins/hasRole.js'

export default {
	name: 'AppBar',
	mixins: [hasRole],
	data() {
		return {
			toggle: null,
		}
	},
	methods: {
		async logout() {
			try {
        await axios.post('api/v1/auth/logout')			
        this.$store.dispatch('deleteUser')
        this.$router.push('/login')
      } catch (error) {

			}
		},
		userRoute() {
      this.$router.push('/user')
    }
	},
	computed: {
    getItemsDashboard(){          
      return this.itemsDashboard.filter( item => {
        return item.inDashboard === true
      })             
    },
    ...mapGetters({
      itemsDashboard:'getItemsDashboard',
			user: 'getUser'
		})
	}
}
</script>

<style>
  
  .v-list-group__items .v-list-item {
    padding-left:30px !important;
  }

	.v-list-item__icon {
		margin-right: 10px !important;
	}

  .v-list-item__icon.v-list-group__header__prepend-icon{
    margin-right: 15px !important;
  }

  .v-list-item__icon.v-list-group__header__append-icon{
    margin: 0px !important;
  }

  #naviMarketButton {
    padding-left:50px;
  }

  #naviAdminButton{
    padding-left:50px;
  }

  #logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
</style>